module.exports = __webpack_public_path__ + "img/img_popup_chatbot.bf29145f.png";